import React, { PropsWithChildren } from 'react';

export const DrawerContent: React.FC<PropsWithChildren> = ({ children }) => <div id="navbar-body">{children}</div>;
